import type { FC, PropsWithChildren } from 'react';
import { ScBadge } from './styled';

export const Badge: FC<PropsWithChildren> = ({ children }) => (
  <ScBadge>
    <div className="bg" />
    <div className="content">{children}</div>
  </ScBadge>
);
